import React, { Suspense, lazy, useState } from 'react';
import UserPlansHistory from './UserPlansHistory';

const PaymentSection = lazy(() => import('./paymentsection'));

function UserPlansTabs() {
  const [activeTab, setActiveTab] = useState('current');

  return (
    <div className="w-full min-h-[calc(100vh-4rem)] bg-gradient-to-br from-slate-100 via-indigo-50 to-cyan-100">
      <div className="sticky top-16 z-20 bg-transparent backdrop-blur-sm pt-4 pb-2 px-4 sm:px-5">
        <div className="max-w-5xl mx-auto flex justify-center">
          <div className="rounded-2xl bg-white/85 border border-slate-200/90 p-1.5 w-full max-w-sm backdrop-blur-sm">
            <div className="relative grid grid-cols-2">
              <span
                className={`absolute top-0 bottom-0 w-1/2 rounded-xl bg-gradient-to-r from-violet-500 to-indigo-500 shadow-lg shadow-indigo-300/60 transition-transform duration-300 ${
                  activeTab === 'current' ? 'translate-x-0' : 'translate-x-full'
                }`}
              />
              <button
                type="button"
                onClick={() => setActiveTab('current')}
                className={`relative z-10 rounded-xl px-4 py-2 text-sm font-bold transition-colors ${
                  activeTab === 'current' ? 'text-white' : 'text-slate-600'
                }`}
              >
                Current Plan
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('history')}
                className={`relative z-10 rounded-xl px-4 py-2 text-sm font-bold transition-colors ${
                  activeTab === 'history' ? 'text-white' : 'text-slate-600'
                }`}
              >
                History
              </button>
            </div>
          </div>
        </div>
      </div>

      {activeTab === 'current' ? (
        <Suspense fallback={<div className="min-h-[40vh]" aria-hidden />}>
          <PaymentSection />
        </Suspense>
      ) : (
        <UserPlansHistory />
      )}
    </div>
  );
}

export default UserPlansTabs;
